import * as R from 'ramda';
import { CaseGranulometry } from '../../../CaseGranulometry';
import { getTopLevelLodgmentSectionsCount } from '../../../../levels/queries/topLevels/counts/getTopLevelLodgmentSectionsCount';
import { getCaseTopLevels } from '../../levels/getCaseTopLevels';

export const getCaseLodgmentSectionsCount = (caseGranulometry: CaseGranulometry): number =>
  R.sum(getCaseTopLevels(caseGranulometry).map(getTopLevelLodgmentSectionsCount));
